<template>
  <div class="increase-service-prices">
    <div class="increase-service-prices__form">
      <form v-on:submit.prevent="onSubmit">
        <p class="increase-service-prices__form__input">
          Повысить цены на
          <input-text
            class="increase-service-prices__form__input-text"
            rows="1"
            name="increase"
            v-model="increasePercent"
            v-mask="`###`"
            type="number"
          />
          %
        </p>
        <p
          class="increase-service-prices__violation"
          role="alert"
          v-for="violationText in increasePercentInputErrors"
          v-bind:key="violationText"
        >{{ violationText }}</p>
        <div class="increase-service-prices__form__controls">
          <button
            class="increase-service-prices__form__controls__button-send"
            type="submit"
          >Далее</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import InputText from '@/components/InputText.vue';

/**
 * @description Название события "Отмена".
 * @type {string}
 */
const NAME_EVENT_CANCEL = 'cancel';

/**
 * @description Название события "Отправить форму".
 * @type {string}
 */
const NAME_EVENT_SUBMIT = 'submit';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

export default {
  name: 'IncreaseServicePricesModal',
  components: { InputText },
  computed: {
    increasePercentInputErrors() {
      return resolveInputErrors('increase-percent');
    },
  },
  methods: {
    /**
     * @description Обработать событие отправки формы.
     * @returns {void}
     */
    onSubmit() {
      this.$emit(NAME_EVENT_SUBMIT, this.increasePercent);
    },
    /**
     * @description Обработать событие отмены.
     * @returns {void}
     */
    onCancel() {
      this.$emit(NAME_EVENT_CANCEL);
      this.refreshIncreasePercent();
    },
    /**
     * @description Обновить значение увеличения.
     * @returns {void}
     */
    refreshIncreasePercent() {
      this.increasePercent = '0';
    },
  },
  data() {
    return {
      /**
       * @description Значение увеличения.
       * @type {string}
       */
      increasePercent: this.initialIncreasePercent,
      /**
       * @description Обработанные услуги.
       * @type {Array}
       */
      processingServices: [],
    };
  },
  props: {
    /**
     * @description Список нарушений.
     * @type {string[]}
     */
    inputError: {
      required: true,
      type: Object,
    },
    /**
     * @description Услуги
     * @type {string}
     */
    initialIncreasePercent: {
      type: String,
      required: false,
      default: () => '0',
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.increase-service-prices {
  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: .125rem;
  }
  &__form {
    &__input {
      display: flex;
      justify-content: center;
      flex-direction: row !important;
      margin: 0 auto;
      height: 50px;
      line-height: 50px;
      vertical-align: center;
    }
    &__input-text {
      width: 30%;
    }
    &__controls {
      width: 100%;
      max-width: 340px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin: 30px auto 0;
      &__button-cancel {
        @include buttons.btn-transparent(170px, 45px, 16px);
        max-width: 100%;
        &:before {
          content: "";
          background-repeat: no-repeat;
          background-size: contain;
          text-align: center;
        }
        &:disabled {
          border-color: var(--unfocus-color);
        }
      }
      &__button-send {
        @include buttons.btn-blue(170px, 45px, 16px);
        max-width: 100%;
        &:before {
          content: "";
          background-repeat: no-repeat;
          background-size: contain;
          text-align: center;
        }
        &:disabled {
          border-color: var(--unfocus-color);
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .increase-service-prices {
    &__form {
      &__controls {
        flex-direction: column;
      }
    }
  }
}
</style>
